import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TrackList, delTrackList, mapQuery, trackDevices } from '@blade-sxp/search-center/api/index';
import DeviceListCard from '@blade-sxp/search-center/pages/components/result/components/deviced.vue';
import { searchCenterStore } from '@blade-sxp/search-center/store/searchCenter';
import mapboxgl from 'mapbox-gl';
import GisMap from '@blade/common-ui/map/gis/index.vue';
import { baseLineLayer, baseLineSource } from '@blade/common-ui/map/gis/utils/base-define';
import { addLabel } from '@blade/common-ui/map/gis/utils/index';
import RouteLeft from '@blade-sxp/search-center/pages/components/result/components/route-left.vue';
const LINE_COLOR = 'black';
const LAYER_ID = 'lineLayer';
const SOURCE_ID = 'lineSource';
const LINE_WIDTH = 1;
let AlarmCenter = class AlarmCenter extends Vue {
    routeDialogVisible;
    selectTrackId = 0;
    zoneId = '';
    seletDeviceId = '';
    // visibleConfirm: boolean = false;
    mapName = '';
    mapUrl = '';
    // map!: mapUtil;
    leftInfoList = [];
    lineList = [];
    mapPointArr = [];
    deviceList = [];
    map;
    deviceMarkers = {};
    mapOptions;
    hasInit = false;
    loaded(map) {
        this.map = map;
        this.initMapSetting();
        this.drawLine();
        this.drawDeviceCard();
    }
    initMapSetting() {
        if (!this.map || !this.mapOptions || this.hasInit)
            return;
        for (const type in this.mapOptions) {
            if (type === 'container')
                continue; // 地图id
            const curType = type;
            const toUpperType = type.replace(type[0], type[0].toUpperCase());
            const registryType = `set${toUpperType}`;
            this.$refs.gisMap[registryType](this.mapOptions[curType]);
        }
        this.hasInit = true;
    }
    mounted() { }
    zoomReset() {
        if (!this.mapOptions)
            return;
        const { center, zoom } = this.mapOptions;
        this.map.setCenter(center);
        this.map.setZoom(zoom);
    }
    zoomIn() {
        const oldZoom = this.map.getZoom();
        this.map.setZoom(oldZoom + 1);
    }
    zoomOut() {
        const oldZoom = this.map.getZoom();
        this.map.setZoom(oldZoom - 1);
    }
    getIndex(array) {
        // 确定下标展示
        array.forEach((element, index) => {
            element.showIndex = index + 1;
        });
        return array;
    }
    isSelectTrack(id) {
        return id === this.selectTrackId;
    }
    // 连线连续数字
    arrConcat(arr) {
        let newArr = arr.map((item) => {
            return Number(item);
        });
        let len = newArr.length;
        let output = [];
        let i;
        for (i = 0; i < len; i++) {
            let start = newArr[i];
            let j;
            for (j = i; j < len; j++) {
                if (newArr[j] + 1 !== newArr[j + 1]) {
                    break;
                }
            }
            i = j;
            if (start === newArr[j]) {
                output.push(start);
            }
            else {
                output.push(start + '-' + newArr[j]);
            }
        }
        return output;
    }
    // 获取地图设备坐标
    getTrackDevices(id) {
        this.lineList = [];
        try {
            id &&
                id !== '0' &&
                trackDevices(id).then((res) => {
                    this.mapPointArr = res;
                    this.mapPointArr.forEach((item) => {
                        let showIndexArr = [];
                        this.leftInfoList.forEach((ele) => {
                            if (item.deviceId === ele.deviceId && !ele.isHide) {
                                showIndexArr.push(ele.showIndex);
                            }
                        });
                        item.showIndex = showIndexArr.join();
                    });
                    this.mapPointArr = this.mapPointArr.filter((item) => item.showIndex);
                    this.mapPointArr.forEach((item) => {
                        item.showIndex = this.arrConcat(item.showIndex.split(',')).join();
                    });
                    this.mapPointArr.sort((a, b) => {
                        return Number(a.showIndex.split(',')[0].split('-')[0]) - Number(b.showIndex.split(',')[0].split('-')[0]);
                    });
                    sessionStorage.setItem('mapPointArr', JSON.stringify(this.mapPointArr));
                    this.deviceList = this.mapPointArr;
                    this.mapPointArr.map((item) => {
                        const vertice = item.vertices;
                        this.lineList.push([vertice.x, vertice.y]);
                    });
                    this.drawLine();
                    this.drawDeviceCard();
                });
        }
        catch (error) { }
    }
    // 画设备卡片
    drawDeviceCard() {
        if (!this.lineList.length || !this.map)
            return;
        this.removeOldDevices();
        this.mapPointArr.forEach((item) => {
            const { x, y } = item.vertices;
            const dom = addLabel(DeviceListCard, { data: () => ({ trackData: item, deviceId: item.deviceId }), i18n: this.$i18n });
            this.deviceMarkers[item.deviceId] = new mapboxgl.Marker({
                element: dom,
            })
                .setLngLat([x, y])
                .addTo(this.map);
        });
    }
    // 画线
    drawLine() {
        if (!this.lineList.length || !this.map)
            return;
        const lineSource = baseLineSource(this.lineList);
        if (!this.map.getLayer(LAYER_ID)) {
            this.map.addSource(SOURCE_ID, {
                type: 'geojson',
                data: lineSource,
            });
            const lineLayerData = baseLineLayer(LAYER_ID, SOURCE_ID);
            this.map.addLayer({
                ...lineLayerData,
                paint: {
                    'line-color': LINE_COLOR,
                    'line-width': LINE_WIDTH,
                },
            });
        }
        else {
            // const lineLayer = this.map.getLayer(LAYER_ID);
            // lineLayer.source = lineSource;
            this.map.getSource(SOURCE_ID).setData(lineSource);
        }
    }
    removeOldDevices() {
        for (const key of Object.keys(this.deviceMarkers)) {
            this.deviceMarkers[key].remove();
        }
    }
    // 获取列表
    getTrackList() {
        try {
            TrackList().then((res) => {
                if (res.length > 0) {
                    this.zoneId = res[0].rootZoneId;
                    this.leftInfoList = this.getIndex(res).map((item) => {
                        return {
                            id: item.id,
                            captureUrl: item.captureUrl,
                            deviceId: item.deviceId,
                            deviceName: item.deviceName,
                            zoneId: item.zoneId,
                            trackType: item.trackType,
                            trackTime: item.trackTime,
                            similarity: item.similarity,
                            hasMap: item.hasMap,
                            showIndex: item.showIndex,
                            isHide: false,
                        };
                    });
                    this.getMapQuery();
                    this.getTrackDevices(this.zoneId);
                }
            });
        }
        catch (error) { }
    }
    getMapQuery() {
        mapQuery(this.zoneId, this.$route.meta.code).then((res) => {
            if (!res.mapConfig)
                return;
            this.mapName = res.mapName;
            const mapConfig = JSON.parse(res.mapConfig);
            this.mapOptions = {
                center: [mapConfig.centerLongitude, mapConfig.centerLatitude],
                zoom: mapConfig.defaultLevel,
                maxZoom: mapConfig.maxLevel,
                minZoom: mapConfig.minLevel,
            };
            this.initMapSetting();
        });
    }
    handleClose() {
        this.$emit('update:routeDialogVisible', false);
        this.selectTrackId = 0;
        this.seletDeviceId = '';
        this.zoneId = '';
        this.lineList = [];
    }
    changeRouteDialogVisible(bool) {
        if (bool) {
            this.getTrackList();
        }
    }
    changeseletDeveceId(seletDeviceId) {
        searchCenterStore.updateSelectId(seletDeviceId); // 更改device组件样式
    }
    // 隐藏
    hide(id, bool) {
        let ind = this.leftInfoList.findIndex((item) => item.id === id);
        this.$set(this.leftInfoList, ind, Object.assign(this.leftInfoList[ind], { isHide: bool }));
        this.getTrackDevices(this.zoneId);
    }
    // 删除
    del(id) {
        try {
            delTrackList(String(id)).then((res) => {
                this.$message({ type: 'success', message: `${this.$t('delSuccess')}`, customClass: 'zZindex' });
                this.selectTrackId = 0;
                this.getTrackList();
                if (res === 0) {
                    this.$emit('update:routeDialogVisible', false);
                    this.$parent.clearAllTrack();
                }
            });
        }
        catch (error) { }
    }
    // 选中
    selectTra(item) {
        if (item.isHide || !item.hasMap)
            return;
        this.selectTrackId = item.id;
        this.seletDeviceId = item.deviceId;
    }
};
__decorate([
    Prop()
], AlarmCenter.prototype, "routeDialogVisible", void 0);
__decorate([
    Watch('routeDialogVisible')
], AlarmCenter.prototype, "changeRouteDialogVisible", null);
__decorate([
    Watch('seletDeviceId')
], AlarmCenter.prototype, "changeseletDeveceId", null);
AlarmCenter = __decorate([
    Component({
        name: 'ResultPage',
        components: { GisMap, RouteLeft },
        i18n: {
            messages: {
                'en-us': {
                    airport: 'Airport',
                    delSuccess: 'Deleted successfully',
                },
                zh: {
                    airport: '航空站',
                    delSuccess: '删除成功',
                },
            },
        },
    })
], AlarmCenter);
export default AlarmCenter;
